import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { ActiveUserContextProvider } from "contexts/ActiveUserContext";

class AuthenticatedRoute extends Component {
    static propTypes = {
        path: PropTypes.string.isRequired,
        component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    }
    render() {
        const { children, render, component: Component, accessRoles } = this.props;
        return (
            <ActiveUserContextProvider accessRoles={accessRoles}>
                {
                    typeof render === "function"
                    ?
                    render()
                    :
                    !_.isEmpty(children)
                    ?
                    children
                    :
                    <Component />
                }
            </ActiveUserContextProvider>
        )
    }
}

export default AuthenticatedRoute;